import styled from 'styled-components';
import { GlobalToken } from 'antd';
import { CustomThemeToken } from '@/theme/theme.utils';

type ExtendedToken = GlobalToken & CustomThemeToken;

export const ErrorBubbleContainer = styled.div<{ theme: { token: ExtendedToken } }>`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme: { token } }) => token.marginSM}px;
  padding: ${({ theme: { token } }) => token.paddingMD}px ${({ theme: { token } }) => token.paddingLG}px;
  background-color: ${({ theme: { token } }) => token.colorErrorBg || token.colorError + '15'};
  border: 1px solid ${({ theme: { token } }) => token.colorErrorBorder || token.colorError + '40'};
  border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
  max-width: 80%;
  margin-top: ${({ theme: { token } }) => token.marginXS}px;
`;

export const ErrorIcon = styled.span<{ theme: { token: ExtendedToken } }>`
  font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
  flex-shrink: 0;
  line-height: 1;
`;

export const ErrorContent = styled.div<{ theme: { token: ExtendedToken } }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.marginSM}px;
  flex: 1;
`;

export const ErrorMessage = styled.p<{ theme: { token: ExtendedToken } }>`
  margin: 0;
  color: ${({ theme: { token } }) => token.colorError};
  font-size: ${({ theme: { token } }) => token.fontSize}px;
  line-height: 1.5;
`;

export const RefreshButton = styled.button<{ theme: { token: ExtendedToken } }>`
  display: flex;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginXXS}px;
  padding: ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.paddingSM}px;
  background-color: ${({ theme: { token } }) => token.colorError};
  color: ${({ theme: { token } }) => token.colorTextLightSolid};
  border: none;
  border-radius: ${({ theme: { token } }) => token.borderRadius}px;
  font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  cursor: pointer;
  transition: all 0.3s ease;
  align-self: flex-start;

  &:hover {
    background-color: ${({ theme: { token } }) => token.colorErrorHover || token.colorError};
    opacity: 0.9;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  svg {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
  }
`;
